import React from 'react';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import Swal from 'sweetalert2';
import { Button } from '@mui/material';
import { confirmBox } from '../../../../utils/utils';

const CancelApptBtn = () => {
    const { appointmentDetails, setAppointmentDetails } = useAppointmentDetailsContext();

    const cancelAppointment = async () => {
        if (await confirmBox('You want to cancel the appointment?')) {
            try {
                Swal.showLoading();
                const url = APIUtils.getAPIEndpoint('cancel-appointment');
                const { data } = await httpClient.post(url, { uniqueId: appointmentDetails.uniqueId });
                if (data.status === 'success') {
                    Swal.fire(data.message, '', 'success');
                    setAppointmentDetails(prev => ({...prev, status: 'CANCELLED'}));
                } else {
                    Swal.fire(data.message, '', 'error');
                }
            } catch (error) {
                Swal.fire('Something went wrong!', '', 'error');
            } finally {
                Swal.hideLoading();
            }
        }
    };

    return <Button  color="error" variant="contained" onClick={cancelAppointment}> Cancel Appointment </Button>;
};

export default CancelApptBtn;